import { render, staticRenderFns } from "./crossCheckAiOcrList.vue?vue&type=template&id=4afc61a4&scoped=true&"
import script from "./crossCheckAiOcrList.vue?vue&type=script&lang=js&"
export * from "./crossCheckAiOcrList.vue?vue&type=script&lang=js&"
import style0 from "./crossCheckAiOcrList.vue?vue&type=style&index=0&id=4afc61a4&lang=scss&scoped=true&"
import style1 from "./crossCheckAiOcrList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc61a4",
  null
  
)

export default component.exports